import { render } from "./AccountBtn.vue?vue&type=template&id=29cbb33a&scoped=true"
import script from "./AccountBtn.vue?vue&type=script&lang=js"
export * from "./AccountBtn.vue?vue&type=script&lang=js"

import "./AccountBtn.vue?vue&type=style&index=0&id=29cbb33a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cbb33a"]])

export default __exports__